// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import useAppSelector from "@insite/client-framework/Common/Hooks/useAppSelector";
import setUserFields from "@insite/client-framework/Store/Pages/UserSetup/Handlers/SetUserFields";
import { getCurrentEditingUser } from "@insite/client-framework/Store/Pages/UserSetup/UserSetupSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import GridContainer from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { GridContainerProps } from "@store/MobiusOverrides/GridContainer/GridContainer";
import { userSettupGridProps, userSettupProps } from "@store/Themes/common/props/userSetup";
import getBooleanProperty from "@toolkit/Framework/Common/Utilities/getBooleanProperty";
import React from "react";

export interface UserSetupPoliciesStyles {
    gridContainer?: GridContainerProps;
    gridItem?: GridItemProps;
    title?: TypographyPresentationProps;
}

export const userSetupPoliciesStyles: UserSetupPoliciesStyles = {
    title: userSettupProps.title,
    gridContainer: userSettupGridProps.container,
    gridItem: userSettupGridProps.item,
};

const styles = userSetupPoliciesStyles;

const UserSetupPolicies = () => {
    const editingUser = useAppSelector(state => getCurrentEditingUser(state));
    const dispatch = useAppDispatch();

    if (!editingUser) {
        return null;
    }

    const canSeePricesChangeHandler: CheckboxProps["onChange"] = (_, value) => {
        dispatch(
            setUserFields({
                properties: {
                    canSeePricesPolicy: String(value),
                },
            } as any),
        );
    };

    return (
        <>
            <Typography {...styles.title} as="h3">
                {translate("Policies")}
            </Typography>
            <GridContainer {...styles.gridContainer}>
                <GridItem {...styles.gridItem}>
                    <Checkbox
                        checked={getBooleanProperty(editingUser.properties.canSeePricesPolicy)}
                        onChange={canSeePricesChangeHandler}
                        disabled={editingUser.role === "Administrator"}
                    >
                        {translate("Can see prices")}
                    </Checkbox>
                </GridItem>
            </GridContainer>
        </>
    );
};

const widgetModule: WidgetModule = {
    component: UserSetupPolicies,
    definition: {
        group: "User Setup",
        displayName: "User Policies",
        allowedContexts: ["UserSetupPage"],
    },
};

export default widgetModule;
